//manages access to the calendar service
angular
  .module('cfn')
  .factory('calendarService', [
    '$http',
    'i18nFilter',
    'languageService',
    calendarService
  ]);

function calendarService($http, i18nFilter, languageService) {
  /**
   * Retrieve the calendar events for this user between the given dates.
   *
   *  @param start {string} events from ('YYYY-MM-DD')
   *  @param end {string} events up to ('YYYY-MM-DD')
   *  @param filter {string} json encoded filter criteria.
   */
  function getCalendarEvents(start, end, filter) {
    return $http({
      url: cs.EVENTS_URL,
      data: $.param({
        currentFilter: filter,
        start: start,
        end: end
      }),
      method: 'POST',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
    }).then(function(response) {
      return response.data;
    });
  }

  var cs = {
    FILTER_URL: '/365FarmNet/rest/calendar/filter',
    EVENTS_URL: '/365FarmNet/rest/calendar/filteredCalender',

    /**
     * @return {Promise}
     */
    getFilter: function() {
      return $http({
        url: cs.FILTER_URL,
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
      }).then(function(response) {
        if (response) {
          var filter = [];
          $.each(response.data, function(i, newFilter) {
            //seems like a workaround to overcome missing values from backend
            newFilter.category = 'Common';
            if (newFilter.uuid !== null) {
              newFilter.category = 'Person';
            } else {
              if (newFilter.type == 'USER') {
                newFilter.name = i18nFilter(
                  'fe.calendar.filter.category.showtasks',
                  'Termine Anzeigen'
                );
              }
              if (newFilter.type == 'Field') {
                newFilter.name = i18nFilter(
                  'fe.calendar.filter.category.field',
                  'Pflanzenbau'
                );
                newFilter.category = 'Operationalbranch';
              } else {
                if (!newFilter.type || newFilter.type === '') {
                  newFilter.name = i18nFilter('fe.calendar.filter.category.missing');
                } else {
                  newFilter.name = i18nFilter(
                    'fe.calendar.filter.category.' + newFilter.type.toLowerCase()
                  );
                }
              }
            }

            filter.push({
              uuid: newFilter.uuid ? newFilter.uuid : '',
              type: newFilter.type ? newFilter.type : '',
              name: newFilter.name ? newFilter.name : '',
              category: newFilter.category ? newFilter.category : '',
              selected: newFilter.selected ? newFilter.selected : false
            });
          });

          return filter;
        }
      });
    },

    /**
     * Full calendar uses this method signature to fetch events from the server
     *
     *  @param start {moment} events from
     *  @param end {moment} events up to
     *  @param filter {Object} if not set the calendar cookie will be used.
     */
    fetchFullCalendarEvents: function(start, end, filter) {
      return getCalendarEvents(
        start.toISOString(),
        end.toISOString(),
        JSON.stringify(filter)
      );
    },

    getFullCalendarLang: function() {
      var fullCalendarSupportedLangs = [
          'ar',
          'ar-ma',
          'ar-sa',
          'ar-tn',
          'bg',
          'ca',
          'cs',
          'da',
          'de',
          'de-at',
          'el',
          'en',
          'en-au',
          'en-ca',
          'en-gb',
          'es',
          'fa',
          'fi',
          'fr',
          'fr-ca',
          'he',
          'hi',
          'hr',
          'hu',
          'id',
          'is',
          'it',
          'ja',
          'ko',
          'lt',
          'lv',
          'nb',
          'nl',
          'pl',
          'pt',
          'pt-br',
          'ro',
          'ru',
          'sk',
          'sl',
          'sr',
          'sr-cyrl',
          'sv',
          'th',
          'tr',
          'uk',
          'vi',
          'zh-cn',
          'zh-tw'
        ],
        bestMatchLang;

      bestMatchLang = languageService.getLanguage().toLowerCase();
      if (fullCalendarSupportedLangs.indexOf(bestMatchLang) == -1) {
        // Full calendar does not support our language-country combination or does not need country specific changes
        // Try with language only setting

        bestMatchLang = languageService.getPrimaryLanguage().toLowerCase();

        if (bestMatchLang == 'en') {
          bestMatchLang = 'en-gb';
        }

        if (fullCalendarSupportedLangs.indexOf(bestMatchLang) == -1) {
          // Language is not supported as well, fallback to German
          bestMatchLang = 'de';
        }
      }

      return bestMatchLang;
    }
  };
  return cs;
}

export default calendarService;
